<mat-tab-group
  [mat-stretch-tabs]="stretch()"
  [mat-align-tabs]="align()"
  [selectedIndex]="activeTabIndex()"
  (selectedIndexChange)="onTabChange($event)"
  animationDuration="0ms"
>
  @for (tab of tabs(); track tab.label; let i = $index) {
    <mat-tab>
      <ng-template mat-tab-label>{{ tab.label }}</ng-template>
      @if (i === activeTabIndex()) {
        <ng-container *ngComponentOutlet="tab.content"></ng-container>
      }
    </mat-tab>
  }
</mat-tab-group>
